"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _glamor = require("glamor");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // TODO: [P3] Although this is for development purpose, prettify it


var ROOT_CSS = (0, _glamor.css)({
  color: 'Red',
  margin: 0
});

var SayAlt = function SayAlt(_ref) {
  var speak = _ref.speak;
  return !!speak && _react.default.createElement("pre", {
    className: ROOT_CSS
  }, speak);
};

SayAlt.defaultProps = {
  speak: ''
};
SayAlt.propTypes = {
  speak: _propTypes.default.string
};
var _default = SayAlt;
exports.default = _default;